export const taskError = error => error && error.response && error.response.data && (error.response.data.msg || error.response.data.message) || error && error.message || 'Не удалось выполнить действие. Повторите попытку.';
export const userName = user => user ? [user.last_name, user.first_name].filter(Boolean).join(' ') : 'Не указан';
export function taskDraftId() {
    const bytes = new Uint8Array(16); window.crypto.getRandomValues(bytes);
    bytes[6] = bytes[6] & 15 | 64; bytes[8] = bytes[8] & 63 | 128;
    const hex = Array.from(bytes, value => value.toString(16).padStart(2, '0')).join('');
    return [hex.slice(0, 8), hex.slice(8, 12), hex.slice(12, 16), hex.slice(16, 20), hex.slice(20)].join('-');
}
export function taskBadge(task, now = new Date()) {
    if (Number(task.status) === 1) return {text: 'Закрыта', variant: 'success'};
    const deadline = task.endDate || task.cronDateFormat;
    const date = deadline && new Date(deadline);
    if (task.endDate && date < now) return {text: 'Просрочена', variant: 'danger'};
    if (task.controlDate && new Date(task.controlDate) <= now) return {text: 'Нужен контроль', variant: 'warning'};
    if (date && date.toDateString() === now.toDateString()) return {text: 'Сегодня', variant: 'info'};
    return {text: 'В работе', variant: 'primary'};
}
export function plainHistory(value) {
    // Historical events contain generated links. Parse only in an inert document, never insert HTML.
    const document = new DOMParser().parseFromString(String(value || '').replace(/\\n/g, '\n'), 'text/html');
    document.querySelectorAll('script,style,iframe,object').forEach(node => node.remove());
    return document.body.textContent || '';
}
